import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getProductInfo } from "../../api/product"



const initialState = {

  // main entity store
  productsById: {},

  // fast slug lookup
  productsBySlug: {},

  loading: false,
  error: null

}



////////////////////////////////////////////////////////
// FETCH PRODUCT DETAILS BY SLUG
////////////////////////////////////////////////////////
export const fetchProductDetails = createAsyncThunk(

  "product/fetchProductDetails",

  async (slug, thunkAPI) => {

    try {

      const res = await getProductInfo({
        product_slug: slug
      })

      const product = res.data.data?.[0]

      return product

    } catch (err) {

      return thunkAPI.rejectWithValue(err.response?.data)

    }

  }

)



////////////////////////////////////////////////////////
// SLICE
////////////////////////////////////////////////////////
const productSlice = createSlice({

  name: "product",

  initialState,

  reducers: {

    ////////////////////////////////////////////////////
    // ADD MULTIPLE PRODUCTS
    ////////////////////////////////////////////////////
    addProducts: (state, action) => {

      const products = action.payload || []

      products.forEach(product => {

        const id = product.id || product.public_id
        const slug = product.slug

        state.productsById[id] = {
          ...state.productsById[id],
          ...product
        }

        if (slug) {
          state.productsBySlug[slug] = id
        }

      })

    },



    ////////////////////////////////////////////////////
    // UPDATE PRODUCT
    ////////////////////////////////////////////////////
    updateProduct: (state, action) => {

      const { id, data } = action.payload

      if (!state.productsById[id]) return

      state.productsById[id] = {
        ...state.productsById[id],
        ...data
      }

    },



    ////////////////////////////////////////////////////
    // REMOVE PRODUCT
    ////////////////////////////////////////////////////
    removeProduct: (state, action) => {

      const id = action.payload

      const slug = state.productsById[id]?.slug

      delete state.productsById[id]

      if (slug) {
        delete state.productsBySlug[slug]
      }

    },



    ////////////////////////////////////////////////////
    // CLEAR ALL PRODUCTS
    ////////////////////////////////////////////////////
    clearProducts: (state) => {

      state.productsById = {}
      state.productsBySlug = {}

    }

  },



  //////////////////////////////////////////////////////
  // EXTRA REDUCERS
  //////////////////////////////////////////////////////
  extraReducers: (builder) => {

    builder


      /////////////////////////////////////////////////
      // FETCH PRODUCT DETAILS
      /////////////////////////////////////////////////
      .addCase(fetchProductDetails.pending, (state) => {

        state.loading = true
        state.error = null

      })


      .addCase(fetchProductDetails.fulfilled, (state, action) => {

        state.loading = false

        const product = action.payload

        if (!product) return

        const id = product.id || product.public_id
        const slug = product.slug

        state.productsById[id] = {
          ...state.productsById[id],
          ...product
        }

        if (slug) {
          state.productsBySlug[slug] = id
        }

      })


      .addCase(fetchProductDetails.rejected, (state, action) => {

        state.loading = false
        state.error = action.payload?.message

      })

  }

})



////////////////////////////////////////////////////////
// EXPORT ACTIONS
////////////////////////////////////////////////////////
export const {
  addProducts,
  updateProduct,
  removeProduct,
  clearProducts
} = productSlice.actions



////////////////////////////////////////////////////////
// EXPORT REDUCER
////////////////////////////////////////////////////////
export default productSlice.reducer